var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm._l(_vm.serverConfig, function (server, index) {
        return _c(
          "article",
          {
            key: index,
            staticClass: "memcached-server",
          },
          [
            _c("header", [
              _c(
                "h3",
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$gettext("Memcached-Server")) +
                      " " +
                      _vm._s(index + 1) +
                      "\n                "
                  ),
                  _c("studip-icon", {
                    staticClass: "remove-server",
                    attrs: {
                      shape: "trash",
                      size: 24,
                    },
                    on: {
                      click: function click($event) {
                        $event.preventDefault()
                        return _vm.removeServer(index)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "section",
              {
                staticClass: "col-4",
              },
              [
                _c("label", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$gettext("Hostname")) +
                      "\n                "
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: server.hostname,
                        expression: "server.hostname",
                        modifiers: {
                          trim: true,
                        },
                      },
                    ],
                    attrs: {
                      type: "text",
                      name: "servers[".concat(index, "][hostname]"),
                      placeholder: "localhost",
                    },
                    domProps: {
                      value: server.hostname,
                    },
                    on: {
                      input: function input($event) {
                        if ($event.target.composing) return
                        _vm.$set(server, "hostname", $event.target.value.trim())
                      },
                      blur: function blur($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "section",
              {
                staticClass: "col-2",
              },
              [
                _c("label", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$gettext("Port")) +
                      "\n                "
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: server.port,
                        expression: "server.port",
                        modifiers: {
                          number: true,
                        },
                      },
                    ],
                    attrs: {
                      type: "text",
                      name: "servers[".concat(index, "][port]"),
                      placeholder: "11211",
                    },
                    domProps: {
                      value: server.port,
                    },
                    on: {
                      input: function input($event) {
                        if ($event.target.composing) return
                        _vm.$set(server, "port", _vm._n($event.target.value))
                      },
                      blur: function blur($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
              ]
            ),
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "add-server",
          on: {
            click: function click($event) {
              return _vm.addServer()
            },
          },
        },
        [
          _c("studip-icon", {
            attrs: {
              shape: "add",
              size: 20,
            },
          }),
          _vm._v(
            "\n        " + _vm._s(_vm.$gettext("Server hinzufügen")) + "\n    "
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }